import { HousingSearch } from '../models/housing-search.model';
import { HousingUnit } from '../models/housing-unit.model';

export class GetHousing {
	static readonly type = '[Housing] GetHousing';
	constructor(public search: HousingSearch) {}
}

export class SetHousingSearchPage {
	static readonly type = '[Housing] SetHousingSearchPage';
	constructor(public page: number) {}
}

export class SetHousingSearchFromForm {
	static readonly type = '[Housing] SetHousingSearchFromForm';
	constructor(public search: HousingSearch) {}
}

export class GetTenants {
	static readonly type = '[Housing] GetTenants';
}

export class HousingSearchToggled {
	static readonly type = '[Housing] HousingSearchToggled';
	constructor(public opened: boolean) {}
}

export class SetNewHousingUnit {
	static readonly type = '[Housing] SetNewHousingUnit';
	constructor(public newHousingUnit: HousingUnit) {}
}

export class SetAddHousingError {
	static readonly type = '[Housing] SetAddHousingError';
	constructor(public error: string) {}
}

export class AddHousingUnit {
	static readonly type = '[Housing] AddHousingUnit';
	constructor(public housingUnit: HousingUnit) {}
}

export class GetHousingUnit {
	static readonly type = '[Housing] GetHousingUnit';
	constructor(public id: number) {}
}

export class GetHousingUnitChangeLogs {
	static readonly type = '[Housing] GetHousingUnitChangeLogs';
}

export class SaveHousingUnit {
	static readonly type = '[Housing] SaveHousingUnit';
	constructor(public housingUnit: HousingUnit) {}
}

export class SetHousingUnit {
	static readonly type = '[Housing] SetHousingUnit';
	constructor(public housingUnit: HousingUnit) {}
}

export class ArchiveHousingUnit {
	static readonly type = '[Housing] ArchiveHousingUnit';
	constructor(public housingUnitId: number) {}
}

export class ActivateHousingUnit {
	static readonly type = '[Housing] ActivateHousingUnit';
	constructor(public housingUnitId: number) {}
}
